// extracted by mini-css-extract-plugin
module.exports = {"button":"_1OHPmP","roundButton":"_3K3cFm","icon":"-zdECr"};